import tailwindConfig from "../../../tailwind.config.js";
import {
  fullWidthRoutes,
  railDefaultMode,
  railRouteModes,
  type RailMode,
} from "./constantsUtils";

// Tailwind v4 removed `tailwindcss/resolveConfig`. The only theme data this
// module needs is the custom brand color palette — every name passed to
// getColorHexCodeByColorName lives in theme.extend.colors (see call sites),
// never a Tailwind default. Build that palette directly from the JS config
// (merging any preset extends) instead of resolving the full default theme.
type ColorMap = Record<string, unknown>;
const extractColors = (source: unknown): ColorMap =>
  ((source as { theme?: { extend?: { colors?: ColorMap } } })?.theme?.extend
    ?.colors as ColorMap) ?? {};
export const themeColors: ColorMap = {
  ...((tailwindConfig as { presets?: unknown[] }).presets ?? []).reduce(
    (acc: ColorMap, preset) => ({ ...acc, ...extractColors(preset) }),
    {} as ColorMap
  ),
  ...extractColors(tailwindConfig),
};

export const getPageTitle = (title: string) => {
  return `ora | ${title}`;
};

export const getColorHexCodeByColorName = (colorName: string) => {
  return (getNestedProperty(themeColors, colorName) || colorName) as string;
};

export const getNestedProperty = (obj: any, path: string) => {
  const keys = path.split("-");
  let result = obj;
  for (const key of keys) {
    result = result[key];
    if (result === undefined) {
      return undefined;
    }
  }

  return result;
};

export const openLinkInNewWindow = (link: string) => {
  window.open(link, "_blank", "rel=noopener noreferrer");
};

export const openDocLinkInNewWindow = (link: string) => {
  window.open(link, "_blank", "rel=noreferrer");
};

export const isFullWidthContainer = (route: string): boolean => {
  return fullWidthRoutes.some((fullWidthRoute) =>
    route.includes(fullWidthRoute)
  );
};

/** Which right-rail surfaces this route gets — see `railRouteModes`. */
export const resolveRailMode = (route: string): RailMode => {
  const override = railRouteModes.find(
    ({ path }) => route === path || route.startsWith(`${path}/`)
  );
  return override?.mode ?? railDefaultMode;
};

export const scrollToEndOfElement = (element: HTMLElement) => {
  const parent = element.parentElement || element;
  const offset =
    element.offsetTop +
    element.offsetHeight +
    parseInt(window.getComputedStyle(element).marginBottom);
  parent.scrollTo({
    top: offset - parent.clientHeight,
    behavior: "smooth",
  });
};
